<section class="al-json-viewer">
    <ng-container *ngTemplateOutlet="recursiveSegmentTmpl; context:{ segments: segments }"></ng-container>
</section>

<ng-template #recursiveSegmentTmpl let-segments="segments">
    <section *ngFor="let segment of segments" [ngClass]="['segment', 'segment-type-' + segment.type]">
        <section (click)="toggle(segment, $event)" [ngClass]="{
                                                                'segment-main': true,
                                                                'expandable': isExpandable(segment),
                                                                'selectable': isLeafSelectable && !isExpandable(segment),
                                                                'expanded': segment.expanded
                                                              }">
            <div *ngIf="isExpandable(segment)" class="toggler"></div>
            <span class="segment-key">{{ segment.key }}</span>
            <span class="segment-separator">:</span>
            <span *ngIf="!segment.expanded || !isExpandable(segment)" class="segment-value">
                {{ segment.description }}
            </span>
        </section>
        <section *ngIf="segment.expanded && isExpandable(segment)" class="children">
            <ng-container *ngTemplateOutlet="recursiveSegmentTmpl; context:{ segments: segment.children }">
            </ng-container>
        </section>
    </section>
</ng-template>